export default {
  countryCode: null,
  // @todo make api key dynamic
  googleAPIKey: null,
  supportedZones: ['gb']
}



// WEBPACK FOOTER //
// ./src/modules/geolocation/store/state.js